<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myapplication.missing_document.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title') }} > </span>
            <span class="back_loc">{{ $t('myapplication.missing_document.title') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <v-layout class="step_wrapper type2">
            <v-flex class="active step_box step01">
              <h2>{{ $t('myapplication.missing_document.fields.step_01') }}</h2>
              <p>{{ $t('myapplication.missing_document.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('myapplication.missing_document.fields.step_02') }}</h2>
              <p>{{ $t('myapplication.missing_document.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <ApplicationInformation :receipt_no="receipt_no" />
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <v-row class="mt-25">
              <v-col cols="12" class="pb-0">
                <h2 class="m_title">{{ $t('myapplication.missing_document.fields.document_history') }}</h2>
                <div class="librarian_box mt-25" style="text-align: inherit; font-size: 13px; height: auto; padding: 30px; justify-content : left;">
                <ul>
                  <li>
                    <h4>{{ $t('application.fields.lazy_required_document') }}</h4>
                    <ul style="font-weight: normal">
                      <li>{{ $t('application.fields.lazy_required_document_1') }}</li>
                      <li>{{ $t('application.fields.lazy_required_document_2') }}</li>
                      <li>{{ $t('application.fields.lazy_required_document_3') }}</li>
                    </ul>
                  </li>
                </ul>
              </div>
              </v-col>
            </v-row>

            <ValidationObserver ref="observer">
              <v-form v-model="valid">
                <template  v-for="(item, index) in attachDocList">
                  <v-flex class="item_box" :key="index">
                    <h2 class="inner_title"><i v-if="item.ind_required == 'Y'">* </i>{{ $vuetify.rtl ? item.name_ar : item.name_en }} <span class="pl-15 important_color" v-if="item.ind_submitted === 'N'">{{$t('myapplication.missing_document.fields.not_submitted_yet')}}</span></h2>
                    <div class="d-flex mt-15">
                      <div class="file_inpt wp50" ref="inpArray">
                        <template v-for="(document_file, file_index) in item.document_files">
                          <div class="fileForm" :key="file_index">
                            <ValidationProvider v-slot="{ errors }" :name="$vuetify.rtl ? item.name_ar : item.name_en" :rules="{required: item.ind_required === 'Y' && !document_file.document_file_key}">
                              <v-file-input
                                :accept="fnGetAcceptExts(item.doc_exts)"
                                solo
                                outlined
                                flat
                                dense
                                :placeholder="document_file.document_file_name ? document_file.document_file_name : $t('common.common.no_files_selected')"
                                :prepend-icon="$t('common.common.select_file')"
                                class="login_text_filed"
                                v-model="document_file.file"
                                :error-messages="errors"
                                :append-icon="document_file.document_file_name ? '$clear':''"
                                @click:append="fnInitFileForm(document_file)"
                                clearable
                                @click:clear="fnInitFileForm(document_file)"
                                @change="fnUploadFile(item, document_file)"
                                style="height:40px;"
                              >
                              </v-file-input>
                            </ValidationProvider>
                            <v-text-field v-model="document_file.document_file_seq" v-show="false"></v-text-field>
                            <v-text-field v-model="document_file.document_file_key" v-show="false"></v-text-field>
                          </div>

                          <div :key="file_index + '_btn'" >
                            <v-spacer class="hidden_lr5"></v-spacer>
                            <div v-if="item.ind_multi_upload == 'Y'">
                              <v-btn
                                color="#333"
                                outlined
                                width="70"
                                height="40"
                                class="ft-size12 text-capitalize lcolor-ddd"
                                @click="fnAddFileForm(item)"
                                v-show="file_index === 0"
                              >
                                {{ $t('appealoppsition.opposition.fields.add_document') }}
                              </v-btn>
                              <v-btn
                                color="#333"
                                outlined
                                width="70"
                                height="40"
                                class="ft-size12 text-capitalize lcolor-ddd"
                                @click="fnDelFileForm(document_file, file_index)"
                                v-show="file_index > 0"
                              >
                                {{$t('common.button.delete')}}
                              </v-btn>
                            </div>
                          </div>

                          <div :key="'poa_'+ file_index" class="input_text_type_basic pa-15 pt-0 pb-0" v-if="item.ipas_userdoc_code === '5009'">
                            <v-row class="pt-0 mt-0">
                              <v-col class="pb-0" cols="12">
                                <h2 class="inner_title">{{ $t('component.representative.the_power_of_attorney_is_already_in_the_possession_of_the_office') }}</h2>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="pt-0">
                                <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.application_no')" :rules="{required: false}">
                                  <h2 class="title_application_no mt-15">{{$t('component.search_application.fields.application_no')}}</h2>
                                  <div class="application__new__wrap">
                                    <v-text-field
                                      dense
                                      outlined
                                      class="ft-size12 br_none email"
                                      style="max-width:250px"
                                      placeholder="EG/P/YYYY/#####"
                                      v-model="poaReferenceAppNo"
                                      :error-messages="poaReferenceAppNo ? errorText : errors"
                                      :success="isChecked && chkResult"
                                      :error="isChecked && !chkResult"
                                    >
                                    </v-text-field>
                                    <v-btn
                                      class="ft-size12 text-capitalize br_none new__check__btn"
                                      dense
                                      color="#a01c2a"
                                      dark
                                      width="95"
                                      height="40"
                                      @click="fnSearchApplication()"
                                    >{{ $t('common.button.check') }}</v-btn>

                                    <v-icon
                                      class="status_icon new__type"
                                      color="success"
                                      style="top: 30%"
                                      v-if="isChecked && chkResult"
                                    >
                                      mdi-check
                                    </v-icon>

                                    <v-icon
                                      class="status_icon new__type"
                                      color="red"
                                      style="top: 30%"
                                      v-if="isChecked && !chkResult"
                                      @click="fnInitSearch()"
                                    >
                                      mdi-close
                                    </v-icon>
                                  </div>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                          </div>
                          <template v-for="(historyItem, historyIndex) in documentHistoryList">
                            <div class="wp100 mt-0" :key="file_index +'_'+ historyIndex" v-if="item.spec_type_code === historyItem.spec_type_code && item.lang_type_code === historyItem.lang_type_code && historyItem.documents.length > 0">
                              <div class="file_list_chip mb-0 d-flex align-center" v-for="(document, subIndex) in historyItem.documents" :key="subIndex">
                                <template v-if="document.ipas_userdoc_code === item.ipas_userdoc_code">
                                  <label class="date nec_title">{{document.receipt_date}}</label>
                                  <v-spacer class="hidden_lr10"></v-spacer>

                                  <div class="file__uploadlist" @click="fnFileDownload(document)" style="cursor:pointer;">
                                    <v-icon color="#398539" v-if="document.file_ext === 'doc' || document.file_ext === 'docx'">mdi-file-word</v-icon>
                                    <v-icon color="#b30b00" v-else-if="document.file_ext === 'pdf'">mdi-file-pdf</v-icon>
                                    <v-icon v-else-if="document.file_ext === 'jpg' || document.file_ext === 'gif' || document.file_ext === 'tif' || document.file_ext === 'bmp' || document.file_ext === 'png' || document.file_ext === 'jpge'">mdi-file-image</v-icon>
                                    <v-icon v-else>mdi-file-document</v-icon>
                                    <span class="file_desc ml--5 mr--5">{{document.file_name}}</span>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </template>
                        </template>
                        <v-text-field v-model="item.user_document_config_seq" v-show="false"></v-text-field>
                        <v-text-field v-model="item.document_seq" v-show="false"></v-text-field>
                      </div>
                    </div>
                  </v-flex>
                </template>
              </v-form>
            </ValidationObserver>
          </v-layout>


          <v-row class="ma-0 mt-15">
            <v-col cols="12" class="d-flex pa-0">
              <v-spacer></v-spacer>
              <v-btn
                dense
                height="50"
                width="150"
                dark
                color="#a01c2a"
                class="capitalize btn_basic br_none"
                @click="fnNext()"
              >
                {{ $t('common.button.next') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>


      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ApplicationInformation from '@/components/layout/ApplicationInformation'

export default {
  components :{
    ValidationObserver,
    ValidationProvider,
    ApplicationInformation
  },
  data () {
    return {
      valid : false,

      receipt_no : this.$route.params.receipt_no,
      attachDocList : [],
      documentHistoryList: [],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      poaReferenceAppNo: '',

      isChecked : false,
      chkResult : false,
      errorText : null
    }
  },
  watch: {
    poaReferenceAppNo () {
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.$refs.observer.reset()
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetContent()
    this.fnGetAttachDocList()
  },
  methods : {
    fnGetContent(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.poaReferenceAppNo = res.data.poa_reference_app_no
            if (this.poaReferenceAppNo !== '') {
              setTimeout(() => {
                this.isChecked = true
                this.chkResult = true
                this.errorText = null
              }, 500)
            }
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6405'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetDocumentHistoryList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/application/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentHistoryList = res.data.list

            this.attachDocList.forEach(item => {
              item.ind_submitted = 'N'
              this.documentHistoryList.forEach(subItem => {
                if (item.spec_type_code === subItem.spec_type_code && item.lang_type_code === subItem.lang_type_code && subItem.documents.length > 0) {
                  item.ind_submitted = 'Y'
                }
              })
            })
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentHistoryList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAttachDocList(){
      requestApi({
        url: '/receivings/missing/document/' + this.receipt_no + '/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let docList = res.data.list

            docList.forEach( item => {
              if(item.document_files.length == 0){
                //넘겨받은 데이터에서 파일 목록이 없을 경우 초기 셋팅을 해야 한다
                let defaultForm = {
                  document_file_seq : '',
                  document_file_key : '',
                  document_file_name : '',
                  file : null
                }
                item.document_files.push(defaultForm)
              }else{
                //넘겨받은 데이터에서 파일 목록이 있을 경우 파일폼만 추가
                item.document_files.forEach( doc_item => {
                  doc_item.file = null
                })
              }
            })

            this.attachDocList = docList
            this.fnGetDocumentHistoryList()
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAttachDocList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAcceptExts(doc_exts){
      let accept = ""

      doc_exts.forEach(item => {
        if(accept.length > 0){
          accept = accept + ","
        }
        accept = accept + "."+item.name_en
      })

      return accept
    },

    fnNext() {
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          if(this.poaReferenceAppNo !== '' && (!this.isChecked || !this.chkResult)) {
            let option = {
              text : this.$t('component.representative.check_application_no')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            return
          }

          this.fnSetPoaReferenceAppNo().then(() => {
            let params = []
            let attachDocList = this.attachDocList
            for(let i=0; i<attachDocList.length; i++){

              for(let k=0; k<attachDocList[i].document_files.length; k++){
                let paramItem = {
                  user_document_config_seq : attachDocList[i].user_document_config_seq,
                  document_seq : attachDocList[i].document_seq,
                  document_file_seq : attachDocList[i].document_files[k].document_file_seq,
                  document_file_key : attachDocList[i].document_files[k].document_file_key,
                  ind_multi_upload: attachDocList[i].ind_multi_upload
                }

                params.push(paramItem)
              }
            }

            requestApi({
              url: '/receivings/missing/document/' + this.receipt_no + '/documents',
              method: 'PUT',
              data: params,
              callback: (res) => {
                if (res.res_code === '200') {
                  this.$router.push({path : '/myapplication/submitmissingdocument/step2/' + this.$route.params.receipt_no })
                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnNext()
                    })
                  } else if (res.res_code === '408') {
                    // timeout이 발생하는 경우 발생하는 팝업의 안내문구 변경
                    let options = {
                      receipt_no: this.receipt_no,
                      search_type_code: '6405'
                    }
                    eventBus.$emit('SHOW_DIALOG_TIMEOUT', options)
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          }).catch((res) => {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnNext()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },

    fnUploadFile(item, documentFile) {
      let fileExts = item.doc_exts
      let uploadFile = documentFile.file
      let specTypeCode = item.spec_type_code
      let langTypeCode = item.lang_type_code

      if(uploadFile != null){
        if (utils.getFileExtLen(uploadFile, fileExts, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            documentFile.file = null
            documentFile.document_file_key = ''
            documentFile.document_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", uploadFile)
        formData.append("spec_type_code", specTypeCode)
        formData.append("lang_type_code", langTypeCode)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            if (res.res_code === '200') {
              documentFile.document_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadFile(item, documentFile)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                documentFile.file = null
                documentFile.document_file_key = ''
                documentFile.document_file_name = ''
              }
            }
          }
        })
      }
    },

    fnAddFileForm(item){
      let defaultForm = {
        document_file_seq : '',
        document_file_key : '',
        document_file_name : '',
        file : null
      }
      item.document_files.push(defaultForm)
    },

    fnDelFileForm(documentFile, index){
      documentFile.splice(index, 1)
    },

    fnInitFileForm(documentFile) {
      documentFile.document_file_key = ''
      documentFile.document_file_name = ''
      documentFile.file = null
      documentFile.pdf_file_name = ''
      documentFile.pdf_file_path = ''
    },

    fnFileDownload(item) {
      requestApi({
        url: '/file/download/' + item.file_key + '/pdf/' + item.file_name,
        method: 'GET',
        responseType: 'blob',
        callback: (res) => {
          if (res.res_code === '401012') {
            utils.setTokenRefresh().then(() => {
              this.fnDownloadReceiptPdf()
            })
          } else {
            const downloadUrl = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = downloadUrl
            link.setAttribute('download', item.file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        }
      })
    },
    fnSearchApplication(){
      if(!this.poaReferenceAppNo){
        let snackBarOptions = {
          text: this.$t('common.message.enter_application_no')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      let params = {
        application_no : this.poaReferenceAppNo.trim(),
        ind_applicant_type_check: 'N'
      }

      requestApi({
        url: '/applications/search',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.isChecked = true
            this.chkResult = true
            this.errorText = null
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSearchApplication()
              })
            } else {
              this.isChecked = true
              this.chkResult = false

              this.errorText = this.$vuetify.rtl ? res.res_msg_ar : res.res_msg_en
            }
          }
        }
      })
    },
    fnSetPoaReferenceAppNo() {
      return new Promise((resolve, reject) => {
        let params = {
          poa_reference_app_no: this.poaReferenceAppNo
        }

        requestApi({
          url: '/receivings/'+ this.receipt_no +'/poa/reference',
          method: 'PUT',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              resolve()
            } else {
              reject(res)
            }
          }
        })
      })
    },

    fnInitSearch(){
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.poaReferenceAppNo = ''
    },
  }
}
</script>